import React from "react";
import { ReactComponent as KreskyLogo } from "../assets/kresky-logo-orange.svg";

const KreskyBrandLockup = React.forwardRef(
  (
    {
      className = "",
      mode = "desktop",
      surface = "default",
      onClick,
      isOpen = false,
      controls,
      label = "Pokaż opis KRESKY",
      nodeId = "3502:3081",
    },
    ref
  ) => {
    const classes = [
      mode === "desktop" ? "description description--kresky" : "",
      "kresky-brand-lockup",
      `kresky-brand-lockup--${mode}`,
      surface !== "default" ? `kresky-brand-lockup--${surface}` : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <button
        ref={ref}
        type="button"
        className={classes}
        data-node-id={nodeId}
        data-name="kolektyw by kresky"
        onClick={onClick}
        aria-controls={controls}
        aria-expanded={isOpen}
        aria-label={label}
      >
        <span className="top-text" data-node-id="3498:1765">
          KOLEKTYW
        </span>
        <span
          className="kresky-line"
          data-node-id="3509:429"
          data-name="by kresky"
        >
          <span className="bottom-text" data-node-id="3509:432">
            by
          </span>
          <span
            className="kresky-link"
            data-node-id="3509:433"
            data-name="link KRESKY"
          >
            <KreskyLogo className="kresky-logo" aria-hidden="true" />
          </span>
        </span>
      </button>
    );
  }
);

KreskyBrandLockup.displayName = "KreskyBrandLockup";

export default KreskyBrandLockup;
